import { Configuration, PopupRequest, LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

// Use REACT_APP_CLIENT_ID / REACT_APP_TENANT_ID from .env (same values as api_server.py / CLIENT_ID / TENANT_ID).
// Fallbacks are for legacy dev only — set .env and restart `npm start`.
const resolveRedirectUri = (): string => {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    return process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000';
};

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || "855f73d6-89af-40bc-a528-28748077081f",
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "0f9baa1b-951d-4da3-8b50-f1fe1b555dd2"}`,
        redirectUri: process.env.REACT_APP_REDIRECT_URI || resolveRedirectUri(),
        postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI || resolveRedirectUri(),
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
        // Required for https://localhost (e.g. HTTPS=true in .env) so auth cookies work in the browser
        secureCookies: typeof window !== 'undefined' && window.location.protocol === 'https:',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Delegated scopes for the access token sent to the API.
 * Keep this minimal: Mail.Read / User.Read.All often require admin consent and break sign-in for normal users.
 * The API accepts Microsoft Graph tokens (audience 00000003-...) when CLIENT_ID / TENANT_ID are set on the server.
 */
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. 
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
